import "./home.css";
import logo from "../../assets/stoqqyLogo.svg";
import cameraIcon from "../../assets/camera.svg";
import dark_search from "../../assets/darkSearch.png";
import home_bg from "../../assets/home_bg.png";
import { Button, Grid, Typography } from "@material-ui/core";
import ScrollDetail from "./ScrollDetails";
import { searchSuggestions } from "../../constants";
import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import AlphaAlert from "./AlphaAlert";
import Searchbar from "../../constants/Searchbar";
import { setStates } from "../../redux/states";
import { useHistory } from "react-router-dom";
import { setCamera } from "../../redux/camera";
import Header from "../../constants/Header";
import { withNamespaces } from "react-i18next";
import LanguageMenu from "../../constants/LanguageMenu";

const Home = ({ t }) => {
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  const innerWidth = useSelector((state) => state.innerWidth.value);
  const states = useSelector((state) => state.states.value);
  const camera = useSelector((state) => state.camera.value);
  const dispatch = useDispatch();
  const history = useHistory();
  const ref1 = useRef(null);

  const [suggestions, setSuggestions] = useState([]);
  const [isFixedHeader, setIsFixedHeader] = useState(false);

  useEffect(async () => {
    const response = await searchSuggestions();
    setSuggestions(response);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Stoqqy";
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      const y = window.pageYOffset;
      setIsFixedHeader(y > 680 ? true : false);
    });
  });
  return (
    <>
      {isFixedHeader ? (
        <>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
            }}
          >
            <Header fixed={true} placeHolder={t("search_placeholder")} t={t} />
          </div>
        </>
      ) : null}
      <div
        style={{
          overflow: "hidden",
          position: isDesktopOrLaptop ? "absolute" : "",
          left: 0,
          width: isDesktopOrLaptop ? "100%" : "",
          height: isDesktopOrLaptop ? "700px" : "auto",
        }}
      >
        <div
          className="Root"
          id="root"
          style={{
            padding: isDesktopOrLaptop
              ? "0px 0px 0px 98px"
              : "0px 14px 0px 12px",
            height: isDesktopOrLaptop ? "630px" : "auto",
            maxWidth: "100%",
            paddingLeft: isDesktopOrLaptop
              ? innerWidth > 1440
                ? (innerWidth - 1440) / 2 + 98
                : 98
              : 12,
          }}
          ref={ref1}
        >
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 12}
            style={{ paddingTop: isDesktopOrLaptop ? "43px" : "23px" }}
          >
            <div
              className="StoqqyLogo"
              style={{
                marginBottom: isDesktopOrLaptop ? "175px" : "43px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <img
                src={logo}
                alt="Logo"
                width={isDesktopOrLaptop ? "151px" : "100px"}
                style={{ marginRight: "30px" }}
              />
              <LanguageMenu />
            </div>
            {isDesktopOrLaptop ? null : (
              <Grid container justifyContent="center">
                <AlphaAlert text={t("alpha_banner")} />
              </Grid>
            )}
            <div
              className="Tagline"
              style={{
                margin: isDesktopOrLaptop
                  ? "175px 211px 30px 0"
                  : "37px 35px 27.5px 0",
                display: "flex",
                alignItems: "center",
              }}
            >
              <h1
                style={{
                  fontSize: isDesktopOrLaptop ? "38px" : "28px",
                  margin: 0,
                }}
              >
                {t("home_tag")}
                {/* Ask Stoqqy! The anything-finance search magic. */}
              </h1>
            </div>
            <div
              style={{
                margin: isDesktopOrLaptop
                  ? "30px 208px 30px 0"
                  : "30px 0px 0px 0px",
                width: "95%",
                maxWidth: "597px",
              }}
            >
              <Searchbar placeHolder={t("search_placeholder")} />
            </div>
            {isDesktopOrLaptop ? (
              <Typography
                style={{
                  paddingBottom: "10px",
                  fontFamily: "Overpass",
                  fontSize: "16px",
                  fontWeight: 600,
                  letterSpacing: "normal",
                  color: "#16063b",
                }}
              >
                {t("search_suggestions")}
              </Typography>
            ) : null}
            <div>
              {suggestions?.map((suggestion, i) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: isDesktopOrLaptop ? "0px" : "16px",
                    }}
                    key={i}
                  >
                    <Button
                      fullWidth
                      size={isDesktopOrLaptop ? "small" : "medium"}
                      style={{
                        textTransform: "capitalize",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        padding: "0px",
                        height: "21px",
                        marginBottom: "15px",
                      }}
                      onClick={() => {
                        dispatch(
                          setStates({
                            ...states,
                            companies: [],
                            filters: {},
                            Sectors: [],
                            name: suggestion?.seggestion,
                            ISIN: null,
                          })
                        );
                        history.push(
                          `/search-results/${suggestion?.seggestion}/1`
                        );
                      }}
                    >
                      <img src={dark_search} alt="search" height="15px"></img>
                      <Typography
                        variant="body1"
                        style={{
                          fontFamily: "Overpass",
                          fontSize: "16px",
                          fontWeight: 300,
                          letterSpacing: "normal",
                          color: "#16063b",
                          paddingLeft: "10px",
                          paddingTop: "2px",
                        }}
                      >
                        {suggestion?.seggestion}
                      </Typography>
                    </Button>
                  </div>
                );
              })}
            </div>
            {isDesktopOrLaptop ? null : (
              <Grid container justifyContent="center">
                <Button
                  style={{
                    height: "45px",
                    marginTop: "38px",
                    borderRadius: "22.5px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textTransform: "capitalize",
                    backgroundColor: "#0040ff",
                    marginBottom: "25px",
                    padding: "0 18px",
                  }}
                  onClick={() => {
                    dispatch(setCamera({ ...camera, isOpen: true }));
                  }}
                >
                  <Typography
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      fontStretch: "normal",
                      fontStyle: "normal",
                      lineHeight: "normal",
                      letterSpacing: "normal",
                      fontFamily: "Overpass",
                      color: "#f8f8f8",
                      paddingRight: "10px",
                    }}
                  >
                    Search by logo
                  </Typography>
                  <img
                    src={cameraIcon}
                    width="16px"
                    height="13px"
                    style={{
                      margin: "4px 0 4px 0px",
                    }}
                    alt="cam"
                  ></img>
                </Button>
              </Grid>
            )}
          </Grid>
          {isDesktopOrLaptop ? (
            <Grid
              item
              xs={6}
              style={{
                position: "absolute",
                top: 0,
                right: innerWidth > 1440 ? (innerWidth - 1440) / 2 : 0,
                height: "100vh",
              }}
            >
              <img
                src={home_bg}
                alt="background"
                height="700px"
                // (suggestions.length === 4 ? 200 : 80)
              />
            </Grid>
          ) : null}
        </div>

        {isDesktopOrLaptop ? (
          <div
            style={{
              backgroundColor: "#f8f8f8",
            }}
          >
            <Grid
              item
              xs={12}
              style={{
                height: "80px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <AlphaAlert text={t("alpha_banner")} />
            </Grid>
          </div>
        ) : null}
      </div>
      <div
        style={{
          marginTop: isDesktopOrLaptop ? "710px" : 0,
        }}
      >
        <ScrollDetail />
      </div>
    </>
  );
};

export default withNamespaces()(Home);
